<template>
  <router-view />
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  computed: {
    userSecondaryMenu () {
      return [
        {
          name: 'Profile',
          link: { name: 'user-profile' },
          icon: 'account_circle'
        },
        {
          name: 'Preferences',
          link: { name: 'user-preferences' },
          icon: 'settings'
        },
        {
          name: 'Integrations',
          link: { name: 'integrations' },
          icon: 'device_hub'
        }
        // {
        //   name: 'Billing',
        //   link: { name: 'billing' },
        //   icon: 'credit_card'
        // }
      ]
    }
  },
  watch: {
    project () {
      this.setSecondaryNav(this.userSecondaryMenu)
    }
  },
  mounted () {
    this.setSecondaryNav(this.userSecondaryMenu)
  },
  destroyed () {
    this.setSecondaryNav(null)
  },
  methods: {
    ...mapMutations('navigation', [
      'setSecondaryNav'
    ])
  }
}
</script>

<style>

</style>
